import { LEVELS_SCALE } from '../logLevels';

const indexes = Object.assign(
    ...LEVELS_SCALE.map(
        (level) => (
            { [level]: LEVELS_SCALE.indexOf(level) }
        )
    )
);

/**
 * Does the level is sufficient.
 * @param {string} level - current log level.
 * @param {string} minimalLevel - minimal log level.
 * @returns {boolean}
 */
const isSufficientLevel = (level, minimalLevel) =>
    indexes[level] >= indexes[minimalLevel]
    && Object.hasOwnProperty.call(indexes, level);

export default isSufficientLevel;
